import { render, staticRenderFns } from "./FrenteImpressaoObito.vue?vue&type=template&id=56ba0350&scoped=true&"
import script from "./FrenteImpressaoObito.vue?vue&type=script&lang=js&"
export * from "./FrenteImpressaoObito.vue?vue&type=script&lang=js&"
import style0 from "./FrenteImpressaoObito.vue?vue&type=style&index=0&id=56ba0350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba0350",
  null
  
)

export default component.exports